import React from "react";
import { FormattedMessage } from "react-intl";
import { css } from "@emotion/react";
import PropTypes from "prop-types";
import { margins } from "style";
import { GET_NOT_SELECTED_APPLICATION_REASONS } from "graphql/queries";
import { UPDATE_APPLICANT } from "graphql/mutations";
import DisplayBox from "components/DisplayBox";
import Tags from "components/Tags";
import { SIZE, TYPE } from "components/Form";
import { MODAL_SIZE, withModalForm } from "components/Modal";

/**
 * ApplicationNotSelectedReasons
 *
 * @param {Object}  application
 * @param {Boolean} loading
 */
const ApplicationNotSelectedReasons = ({ application, loading, ...props }) => {
  return (
    <DisplayBox
      numColumns={1}
      editButtonText={<FormattedMessage id="Missions.Applicants.ApplicationNotSelectedReason.EditButton.Text" />}
      loading={loading}
      parentKeyName="id"
      parentKeyValue={application?.id}
      updateId={application?.id}
      initialValues={{
        notSelectedReasons: application?.notSelectedReasons?.map((item) => ({
          name: item.name,
          id: item.id,
        })),
      }}
      data={[
        {
          title: <FormattedMessage id="Missions.Applicants.ApplicationNotSelectedReason.Body.Title" />,
          body: <Tags data={application?.notSelectedReasons} />,
        },
      ]}
      isEmpty={!application?.notSelectedReasons?.length}
      isEditable
      hideHeader
      {...props}
    />
  );
};

const FORM_DATA = [
  {
    style: css`
      width: 100%;
    `,
    items: [
      {
        type: TYPE.tags,
        size: SIZE.xlarge,
        properties: {
          name: "notSelectedReasons",
          placeholder: "Type a reason...",
          queryName: GET_NOT_SELECTED_APPLICATION_REASONS,
          queryKeyName: "notSelectedApplicationReasons",
          autoFocus: true,
          required: true,
          minLength: 0,
          defaultOpen: true,
        },
      },
    ],
  },
];

const FORM_SETTINGS = {
  size: MODAL_SIZE.medium,
  data: FORM_DATA,
  title: <FormattedMessage id="Missions.Applicants.ApplicationNotSelectedReason.Form.Title" />,
  description: <FormattedMessage id="Missions.Applicants.ApplicationNotSelectedReason.Form.Description" />,
  marginSize: margins.xxsmall,
  mutationData: {
    mutationName: {
      update: UPDATE_APPLICANT,
      add: UPDATE_APPLICANT,
    },
  },
};

ApplicationNotSelectedReasons.propTypes = {
  application: PropTypes.object.isRequired,
  loading: PropTypes.bool,
};

export default withModalForm(ApplicationNotSelectedReasons, FORM_SETTINGS);
